<template>
  <button
    class="base-button"
    :type="type"
    :class="mode"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'button'
    },
    mode: {
      type: String,
      default: ''
    }
  }
}
</script>